import apiClient from './apiClient';

class ExchangeClient {
    // 取得用戶星塵摘要
    getUserStardust = (): Promise<any> => apiClient.get('/stardust/summary');

    // 兌換商品
    exchangeItem = (code: string): Promise<any> =>
        apiClient.post('/stardust/redemptions', { code });

    // 填寫兌換收品收件資訊
    putExchangeReceiver = (form: any): Promise<any> =>
        apiClient.put(`/stardust/redemptions/${form.redemptionNo}/receiver`, { ...form });

    // 投入抽獎券
    postLottery = (code: string, ticketCount: number): Promise<any> =>
        apiClient.post('/stardust/lottery/entries', { code, ticketCount });

    // 取得商品兌換列表
    findItems = ({ pageIndex, limit }: { pageIndex: number; limit: number }): Promise<any> =>
        apiClient.get(`/stardust/items`, {
            params: { pageIndex, limit },
        });
}

const exchangeClient = new ExchangeClient();

export default exchangeClient;
